import React, { useEffect, useMemo, useState } from "react";
import { RiArrowDropRightLine, RiFullscreenLine } from "react-icons/ri";
import { IoIosArrowBack, IoIosArrowForward, IoMdClose } from "react-icons/io";
import { BiExitFullscreen, BiFullscreen } from "react-icons/bi";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  closeFullScreen,
  closeVipBar,
  openFullScreen,
  openVipBar,
  storeGameConfig,
} from "../../../redux/action/game/gameAction";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { languageTransfer } from "../../../utils/languageTransfer";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import useGetNowGame from "../../../hook/useGetNowGame";
import ToggleFavorite from "../../../components/Favorite/toggleFavorite";
import LazyImage from "../../../components/Loading/lazyImage";
import LoadingLine from "../../../components/Loading/LoadingLine";
import useGameIsHasDescription from "../gameDescription/gameIsHasDescription";
import { openGameDescriptionPop } from "../../../redux/action/member/memberAction";
import { FaScroll } from "react-icons/fa";
import UseGetGameBoxBackPath from "../../../hook/useGetGameBoxBackPath";

const GameBoxHeader = ({ en_Name, type }) => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  const nowGameConfig = useGetNowGame();

  const dispatch = useDispatch();

  const getPrevPath = UseGetGameBoxBackPath();

  const { to } = useParams();

  useEffect(() => {
    dispatch(storeGameConfig(nowGameConfig));
  }, [nowGameConfig]);

  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);
  const isVipBarOpen = useSelector((state) => state.isVipBar);

  const navigate = useNavigate();

  const [favorite, setFavorite] = useState(false);

  const gameConfig = useSelector((state) => state.isGameConfig);

  const { game_platform, gameCode, game_subtype } = gameConfig;

  const gameIsHasDescription = useGameIsHasDescription({ game_platform });

  const gameName = useMemo(() => {
    return gameConfig?.[
      `gameName${languageTransfer({ lang: i18next.language })}`
    ];
  }, [gameConfig, i18next.language]);

  return (
    <div className="w-full flex items-center justify-between py-[8px] px-[20px] h-[52px] bg-white">
      <div className="font-semibold text-main-color">
        <p className="mb-0 text-xl flex items-center">
          <span className="text-light-text">
            <LoadingLine
              className={`w-[100px] !h-[15px] !mt-0`}
              customInverted={1}
            >
              {game_platform}-{i18n_common(game_subtype)}
            </LoadingLine>
          </span>{" "}
          <RiArrowDropRightLine className="text-4xl" />
          <span>
            <LoadingLine
              className={`w-[100px] !h-[15px] !mt-0`}
              customInverted={1}
            >
              {gameName}
            </LoadingLine>
          </span>
        </p>
      </div>
      <section className="flex items-center gap-[10px] text-grey-text text-3xl">
        <ToggleFavorite />
        {/* {favorite ? (
          <AiFillHeart
            onClick={() => {
              setFavorite(false);
            }}
            className="cursor-pointer hover:text-light-orange"
          />
        ) : (
          <AiOutlineHeart
            onClick={() => {
              setFavorite(true);
            }}
            className="cursor-pointer hover:text-light-orange"
          />
        )} */}
        {isOpenFullScreen ? (
          <BiExitFullscreen
            onClick={() => {
              dispatch(closeFullScreen());
            }}
            className="cursor-pointer hover:text-light-orange"
          />
        ) : (
          <BiFullscreen
            onClick={() => {
              dispatch(openFullScreen());
            }}
            className="cursor-pointer hover:text-light-orange"
          />
        )}
        {gameIsHasDescription && (
          <FaScroll
            onClick={() => {
              dispatch(
                openGameDescriptionPop({
                  game: game_platform,
                })
              );
            }}
            className="cursor-pointer hover:text-light-orange"
          />
        )}
        <IoMdClose
          onClick={() => {
            navigate(`/${getPrevPath}/category/${to}/AllGames`);
          }}
          className="cursor-pointer hover:text-grey-text"
        />
        <div
          className="p-[2px] rounded-full hover:bg-hover-transaction-card bg-transaction-card cursor-pointer"
          onClick={() => {
            if (isVipBarOpen) {
              dispatch(closeVipBar());
            } else {
              dispatch(openVipBar());
            }
          }}
        >
          <div className="relative flex items-center">
            {!isVipBarOpen && (
              <IoIosArrowBack className="text-sm text-base-light-dark" />
            )}
            {/* <img
              src="https://leoncasino.gcdn.co/img/beginner.a4dcaa95.png"
              className="w-[32px] h-[32px]"
            /> */}
            <LazyImage
              src="https://leoncasino.gcdn.co/img/beginner.a4dcaa95.png"
              alt="vip"
              className="w-[32px] h-[32px]"
              loadingClassName="w-[32px] h-[32px] rounded-full"
            />
            {isVipBarOpen && (
              <IoIosArrowForward className="text-sm text-base-light-dark" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GameBoxHeader;
